import React, { useEffect, useState, useMemo, useCallback } from "react";
import { AppBar, Tabs, Tab } from "@material-ui/core";
import TabPanel, { a11yProps } from "./SubComponent/TabPanel";
import TestResult from "./SubComponent/TestResult";
import Loader from "../../shared/Loader/Loader";
import translate from "../../../i18n/translate";
import { LicenseObjectInterface } from "../../../interfaces";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { progressPageIds } from "../../../globalConstants";
import ChartsComponent from "../../shared/ChartsComponent/ChartsComponent";
import LevelTabs from "./SubComponent/LevelTabs";
import ProgressStep from "./StepProgress/ProgressStep";
import { getRandomNumber } from "../../shared/utils/sharedUtils";

interface MandatoryTab {
  productId: string;
  productName: string;
  active: number;
}
type ComponentWrapper = {
  component: JSX.Element;
  wrapperClass?: string;
};

const ProgressDetails = () => {
  const intl = useIntl();
  const mandatoryTabs: MandatoryTab[] = useMemo(
    () => [
      {
        productId: "$0",
        productName: intl.formatMessage({ id: "progress_activity_report" }),
        active: 1,
      },
      {
        productId: "$1",
        productName: intl.formatMessage({ id: "progress_test_results" }),
        active: 1,
      },
    ],
    [],
  );
  const allInfo = useSelector((state: any) => state.peopleInformation); // Specify the specific state slice
  const [value, setValue] = useState(2);
  const [loaderFlag, setLoaderFlag] = useState<boolean>(true);
  const [progressMainTabs, setProgressMainTabs] = useState<MandatoryTab[]>(mandatoryTabs);
  const [tabComponents, setTabComponents] = useState<ComponentWrapper[]>([
    { component: <ChartsComponent />, wrapperClass: "test-results-all-cards-cover white" },
    { component: <TestResult /> },
  ]);
  useEffect(() => {
    if (!allInfo.isLoading && !allInfo.isFailed && allInfo.data) {
      getFirstTabList();
    }
  }, [allInfo]);

  const getFirstTabList = useCallback(() => {
    const licenses = allInfo.data.getpeopleInformation.license;
    const filteredRawLicenses: LicenseObjectInterface[] = licenses?.filter(
      (license: LicenseObjectInterface) =>
        license.active === "1" && progressPageIds.includes(license.productId) && license.productId !== "15",
    );
    let newTabComponents = [...tabComponents];
    filteredRawLicenses.forEach((element) => {
      if (element.productId === "18" || element.productId === "29") {
        newTabComponents.push({ component: <LevelTabs /> });
      } else if (element.productId === "6" || element.productId === "5") {
        newTabComponents.push({ component: <ProgressStep /> });
      }
    });
    setTabComponents(newTabComponents);
    setProgressMainTabs([...mandatoryTabs, ...filteredRawLicenses]);
    setLoaderFlag(false);
  }, [allInfo.data, mandatoryTabs]);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      {loaderFlag && <Loader showLoader={loaderFlag} />}
      <div className="progresspage-container">
        <div className="progresspage-title" data-testid="progress_title_Id">
          <h1>{translate("progress_title")}</h1>
        </div>
        <div className="progresspage-body">
          <div className="progresspage-tab">
            <AppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
              >
                {progressMainTabs.map((product: MandatoryTab, mainIndex: number) => (
                  <Tab key={product.productId} label={product.productName} {...a11yProps(mainIndex)} />
                ))}
              </Tabs>
            </AppBar>
            {tabComponents.length >= 2 &&
              tabComponents.map(
                (tab, index) =>
                  value === index && (
                    <TabPanel key={getRandomNumber(index)} value={value} index={index}>
                      <div className={tab.wrapperClass ?? ""}>{tab.component}</div>
                    </TabPanel>
                  ),
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProgressDetails;
